export default __webpack_public_path__ + "static/media/emptyLeave.6d31cafa.svg";